import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
export const ManipulationDom = () =>{

  function calcHeight(nbLine){
    let calc = 19*nbLine
    return calc+"px"
    }
    return(
    
        <div id="articleContent">
          <h2>Tips Javascript</h2>
  
        <pre>
      <code>
      <AceEditor
        fontSize={16}
        showPrintMargin={false}
        showGutter= {true}
          mode="javascript"
          theme="monokai"
          height={calcHeight(12)}
          width="100%"
          value={`let myVariable = "My variable"

// Exemple de création d'alias
const $ = (selector) => document.querySelector(selector)
console.log($(".mySelector"))

// Exemple de personnalisation de console.log
console.log('%c Nice console.log ', 'background: #313445; color:#FF385E;
font-size:15px;font-weight:bold', myVariable);                            

// Pour afficher un objet et en avoir toutes les informations
console.log(JSON.parse(JSON.stringify(myId)))`}

        />
      </code>
      </pre>
      <div class="pageBreak"></div>

<h2>Manipuler le DOM</h2>
<h3>Accédez aux élements du DOM</h3>
<pre>
      <code>
      <AceEditor
      height={calcHeight(48)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter= {true}
      mode="javascript"
      theme="monokai"
      value={`/********************************************/
.innerHTML("<div>bla</div>")
.textContent("Lorem ipsum")
.classList.add("newClass")
.classList.remove("classToRemove")
.classList.contains("class") // true or false
.classList.replace("oldClass","newClass")
.style.color = "#fff"
.style["color"] = "#fff"
.setAttribute("title","newTitle")
.getAttribute('title')
.createElement("article")
.appendChild(newChild)
.removeChild(removeElement)
.replaceChild(newElement, oldElement)
/********************************************/
// Remplacer un élement par du contenu HTML
let myVar = document.getElementById('myId')
myVar.innerHTML = '<ul><li>Item 1</li><li>Item 2</li></ul>'
// Remplacer un élement par du texte
let myVar = document.getElementById('myId')
myVar2.textContent = 'New text'
// Ajouter une classe à un élement
myId.classList.add("myNewClass")
// Supprimer une classe d'un élement
myId.classList.remove("myClass")
// Vérifier si la class spécifiée est contenu par un élement
myId.classList.contains("myNewClass") // return true or false
// Remplacer une class par une autre
myId.classList.replace("myNewClass","MyClassChange")
// Modifier le style d'un élement en utilisant la propriété style
myId.style.color = "#fff";
myId.style.backgroundColor = "#000";
myId.style.fontWeight = "bold";
myId.style["background-color"] = "red"
// Pour ajouter un attribut ou le modifier
myId.setAttribute("title","newTitle")
// Pour récupérer la valeur d'un attribut 
myId.getAttribute('title') // null is not exist
// Créer un nouvel élement et l'ajouter en tant qu'enfant
const newChild = document.createElement("article")
myId.appendChild(newChild) // S'ajoute à la fin
// Supprimer un élement
const removeElement = document.querySelector("#myId>div")
myId.removeChild(removeElement)
// Remplacer un élement
const elementToReplace = document.querySelector("#myId>ul")
myId.replaceChild(document.createElement("main"), elementToReplace)`}
        />
      </code>
      </pre>
      <h3>Ecouter les évenements</h3>

      <pre>
      <code>
      <AceEditor
      height={calcHeight(42)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter= {true}
      mode="javascript"
      theme="monokai"
      value={`// Liste des MouseEvent les plus utilisé
.addEventListener('click', function(){}); // Au clic entier de la souris (pressé puis relaché)
.addEventListener('dblclick', function(){}); // Au double-clic de la souris
.addEventListener('mouseenter', funsction(){}); // Lorsque le curseur entre sur l'élément
.addEventListener('mouseleave', function(){}); // Lorsque le curseur sort de l'élément ET de tout ses fils
.addEventListener('mouseout', function(){}); // Lorsque le curseur sort de l'élément OU de l'un des fils
.addEventListener('mouseover', function(){}); // Lorsque le curseur est sur l'élément ou l'un des fils
.addEventListener('mousedown', function(){}); // Au clic de la souris (pressé uniquement)
.addEventListener('mouseup', function(){}); // Au déclic de la souris
.addEventListener('mousemouve', function(){}); // détecte le mouvement de la souris

// Liste des forusEvent les plus utilisé
.addEventListener('focus', function(){}); // Lorsqu'un élément à le focus (ne se propage pas)
.addEventListener('focusin', function(){}); // Lorsqu'un élément reçoit le focus (se propage)
.addEventListener('focusout', function(){}); // Lorsqu'un élément perd le focus (se propage)
.addEventListener('blur', function(){}); // Lorsqu'un élément perd le focus (ne se propage pas)

// Autre event
.addEventListener('change', function(){}); // Lorsqu'un changement de valeur est realisé par l'utilisateur sur les élements d'un formulaire

// Un exemple d'évenement, le click
myId.addEventListener('click', function() {// On écoute l'événement click
    myId.innerHTML = "C'est cliqué !";// On change le contenu de notre élément pour afficher "C'est cliqué !"
});

// Un exemple en ajoutant preventDefault
const monLien = document.getElementById('monLien');
monLien.addEventListener('click', function(event) { // On écoute l'événement click, notre callback prend un paramètre que nous avons appelé event ici
    event.preventDefault();// On utilise la fonction preventDefault de notre objet event pour empêcher le comportement par défaut
});

// Un exemple avec le stopPropagation().
// Permet de ne pas propager l'évenement sur les enfants
let divParent = document.querySelector('#divParent');
let divEnfant = document.querySelector('#divEnfant');
divParent.addEventListener('click', function(){alert('div cliqué')});
divEnfant.addEventListener('click', cliqueAndStop);
function cliqueAndStop(event){
    alert('Paragraphe cliqué - Arrêt de la propagation');
    event.stopPropagation();
}`}
        />
      </code>
      </pre>

      <div class="pageBreak"></div>

<h3>Récupérez des données utilisateur avec les événements</h3>

<pre>
      <code>
      <AceEditor
      height="400px"
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter= {true}
      mode="javascript"
      theme="monokai"
      value={`// Récupération des coordonnées du curseur
test.addEventListener('mousemove', function(event) {
  const constOffsetX = event.offsetX; // Coordonnée X de la souris dans l'élément
  const constOffsetY = event.offsetY; // Coordonnée Y de la souris dans l'élément
  const constClientX = event.clientX; // Coordonnée X de la souris dans les coordonnées locales (contenu du DOM) ;
  const constClientY = event.clientY; // Coordonnée Y de la souris dans les coordonnées locales (contenu du DOM) ;
  const constScreenX = event.screenX; // Coordonnée X de la souris par rapport à la fenêtre du navigateur
  const constScreenY = event.screenY; // Coordonnée Y de la souris par rapport à la fenêtre du navigateur
  const constPageX = event.pageX; // Coordonnée X de la souris par rapport au document entier
  const constPageY = event.pageY; // Coordonnée X de la souris par rapport au document entier
  const constMovementX = event.movementX; //Coordonnée X par rapport à la position de la souris lors du dernier événement mousemove
  const constMovementY = event.movementY; //Coordonnée Y par rapport à la position de la souris lors du dernier événement mousemove
  console.log("Position dans l'élément " + constClientX + " " + constClientY)
});

// Lire le contenu d'un champs texte
const inputText = document.getElementById('inputText')
const output = document.getElementById('output')
inputText.addEventListener('input', function(event) {
  output.innerHTML = event.target.value; 
})`}
        />
      </code>
      </pre>

      </div>
    )
}
